module.exports = __webpack_public_path__ + "img/4.39c23235.png";